import React, { useState } from "react";
import Swal from "sweetalert2";
import style from "../../../scss/Catalogos.module.scss";
import estiloPerfil from "../../../scss/Perfil.module.scss";
import { cambiarPassword } from "../../../Api/autenticacion";
import { obtenerMensajeError } from "../../../utils/mensajeError";

const FORMULARIO_VACIO = { passwordActual: "", passwordNueva: "", confirmarPassword: "" };
const MINIMO_CARACTERES = 8;

// mismas reglas que valida el backend; devuelve el primer error o null
const validarFormulario = ({ passwordActual, passwordNueva, confirmarPassword }) => {
  if (passwordNueva.trim().length < MINIMO_CARACTERES)
    return `La nueva contraseña debe tener mínimo ${MINIMO_CARACTERES} caracteres`;
  if (passwordNueva.trim() === passwordActual.trim()) return "La nueva contraseña debe ser diferente a la actual";
  if (passwordNueva.trim() !== confirmarPassword.trim()) return "Las contraseñas nuevas no coinciden";
  return null;
};

const CambiarPasswordComponent = () => {
  const [formulario, setFormulario] = useState(FORMULARIO_VACIO);
  const [verPasswords, setVerPasswords] = useState(false);
  const [guardando, setGuardando] = useState(false);

  const handleChange = (e) => setFormulario({ ...formulario, [e.target.name]: e.target.value });

  // la confirmación se marca en rojo apenas deja de coincidir
  const confirmacionDistinta =
    formulario.confirmarPassword.length > 0 && formulario.confirmarPassword !== formulario.passwordNueva;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const error = validarFormulario(formulario);
    if (error) {
      Swal.fire({ icon: "warning", text: error });
      return;
    }

    setGuardando(true);
    try {
      const respuesta = await cambiarPassword(formulario);
      Swal.fire({ icon: "success", text: respuesta.msg, timer: 1800, showConfirmButton: false });
      setFormulario(FORMULARIO_VACIO);
    } catch (error) {
      Swal.fire({ icon: "error", text: obtenerMensajeError(error) });
    } finally {
      setGuardando(false);
    }
  };

  const tipoCampo = verPasswords ? "text" : "password";

  return (
    <section className={style.tarjeta} aria-labelledby="titulo-cambiar-password">
      <h2 id="titulo-cambiar-password" className={style.titulo}>
        Cambiar contraseña
      </h2>

      <form onSubmit={handleSubmit} className="row g-2">
        <div className="col-12">
          <label htmlFor="perfil-password-actual" className={style.etiqueta}>
            Contraseña actual
          </label>
          <input
            id="perfil-password-actual"
            name="passwordActual"
            type={tipoCampo}
            className="form-control"
            value={formulario.passwordActual}
            onChange={handleChange}
            autoComplete="current-password"
            required
          />
        </div>
        <div className="col-12">
          <label htmlFor="perfil-password-nueva" className={style.etiqueta}>
            Nueva contraseña
          </label>
          <input
            id="perfil-password-nueva"
            name="passwordNueva"
            type={tipoCampo}
            className="form-control"
            value={formulario.passwordNueva}
            onChange={handleChange}
            minLength={MINIMO_CARACTERES}
            maxLength={72}
            placeholder={`Mínimo ${MINIMO_CARACTERES} caracteres`}
            autoComplete="new-password"
            required
          />
        </div>
        <div className="col-12">
          <label htmlFor="perfil-password-confirmar" className={style.etiqueta}>
            Repite la nueva contraseña
          </label>
          <input
            id="perfil-password-confirmar"
            name="confirmarPassword"
            type={tipoCampo}
            className={`form-control ${confirmacionDistinta ? "is-invalid" : ""}`}
            value={formulario.confirmarPassword}
            onChange={handleChange}
            autoComplete="new-password"
            aria-describedby="perfil-password-confirmar-error"
            required
          />
          <div id="perfil-password-confirmar-error" className="invalid-feedback">
            Las contraseñas nuevas no coinciden
          </div>
        </div>
        <div className="col-12">
          <div className={`form-check ${estiloPerfil.interruptor}`}>
            <input
              id="perfil-ver-passwords"
              type="checkbox"
              className="form-check-input"
              checked={verPasswords}
              onChange={() => setVerPasswords(!verPasswords)}
            />
            <label htmlFor="perfil-ver-passwords" className="form-check-label">
              Mostrar contraseñas
            </label>
          </div>
        </div>

        <div className={`col-12 ${style.botones}`}>
          <button type="submit" className={`btn btn-primary ${style.boton}`} disabled={guardando}>
            {guardando ? "Guardando..." : "Cambiar contraseña"}
          </button>
        </div>
      </form>
    </section>
  );
};

export default CambiarPasswordComponent;
